import { omit } from 'lodash';
import { stringify } from 'qs';
import { getClaimDetailInterface } from 'src/config/sceneEnum';
import { query, request } from 'src/utils/request';

// 费用类型
export const reqFeeTypelList = () => {
  return query('/zlb/api/expense/common/feeType/searchType');
};

// 费用类型
export const reqTrainTimeHour = () => {
  return query('/zlb/api/expense/common/trainTimeHour');
};

// 票据类型
export async function reqInvoiceType(data) {
  return query('/zlb/api/invoice/type', { method: 'POST', data });
}
//获取运营机构配置
export async function getMenuAttachmentInfor(data) {
  return query('/zlb/api/expense/attachment/config/query', { method: 'POST', data });
}
//获取运营机构配置项
export async function getRuleInfor(data) {
  return query('/zlb/api/expense/config/rule-option/user/query', { method: 'POST', data });
}
// 报销单列表
export async function getExpenseFormList(data) {
  return query('/zlb/api/expense/expense-form/list', { method: 'POST', data });
}

// 初始化表单信息
export async function initFormBasicInfo(data) {
  return query('/zlb/api/expense/expense-form/initExpenseFormBasicInfo', { method: 'POST', data });
}

// 初始化表单信息 - 通用采购
export async function initFormBasicInfoCommon(data) {
  return query('/zlb/api/expense/expense-form/init-expense-form/purchase', {
    method: 'POST',
    data,
  });
}

// 初始化表单信息-差旅
export async function initFormBasicInfoTrip(data) {
  return request('/zlb/api/expense/expense-form/init-expense-form', {
    method: 'POST',
    data,
  });
}
// 初始化表单信息-一般事项
export async function initFormBasicInfoGeneral(data) {
  return request('/zlb/api/expense/expense-form/init-expense-form/general', {
    method: 'POST',
    data,
  });
}

// 异步ocr识别,返回TaskCode
export async function asyncOcr(data) {
  return query('/zlb/api/invoice/asyncOcr', { method: 'POST', data });
}

// 获取异步ocr识别并验真
export async function getOcrResultAndAuthenticity(code) {
  return query(`/zlb/api/invoice/getOcrResultAndAuthenticity?taskCode=${code}`, { method: 'GET' });
}

// 直接验证并保存
export async function onOcrResultAndAuthenticity(data) {
  return query('/zlb/api/invoice/ocr-real-save', { method: 'POST', data });
}

// 费用查询
export async function getFeeByInvoice(params) {
  return query('/zlb/api/expense/fee/expenseForm/genFeeByInvoice', {
    params,
  });
}

// 多票生成费用
export async function genByMultiInvoice(data) {
  return query('/zlb/api/expense/travel/expense-form/fee/gen-by-multi-invoice', {
    method: 'POST',
    data,
  });
}

// 添加评论
export function submitComment(data) {
  return request('/zlb/api/expense/workflow/addComment', {
    method: 'POST',
    data,
  });
}

// 获取多票配置
export async function getMultiInvoiceConfig(params) {
  return query('/zlb/api/expense/common/dic/multi-invoice-fee/get', {
    params,
  });
}

// 发票列表
export async function getInvoiceList(data) {
  return query('/zlb/api/invoice/newList', { method: 'POST', data });
}

// 发票编辑
export async function editInvoice(data) {
  return query('/zlb/api/invoice/edit', { method: 'POST', data });
}

// 根据行程信息自动生成费用
export async function getFeeByRecord(data) {
  return query('/zlb/api/expense/fee/record/genByRecord', { method: 'POST', data });
}

// 通用的四则运算
export async function calculator(params) {
  return query(`/zlb/api/sop/common/calculator?${stringify(params)}`);
}

// 保存报销单
export async function saveClaim(data) {
  return query('/zlb/api/expense/expense-form/save', { method: 'POST', data });
}

// 删除报销单
export function deleteClaim(params) {
  return query(`/zlb/api/expense/expense-form/delete/${params}`, { method: 'POST' });
}

// 报销单详情
export function getClaimInfo(expenseFormCode) {
  const params = {
    expenseFormCode,
  };
  return query(`${getClaimDetailInterface()}?${stringify(params)}`);
}

// 报销单详情
export function getClaimDetail(params) {
  return query(getClaimDetailInterface(params), { params });
}

// 根据业务code获取百搭报销单单据详情 业务数据详情
export const queryClaimFormDefineByCode = async data => {
  return request('/magic/front/service/zcy.baida.queryFormDefineByExpense', {
    method: 'POST',
    data,
  });
};

// 根据业务code获取百搭报销单单据详情 业务数据详情
export const queryClaimFormDefineByCodeFromCashier = async data => {
  return request('/magic/front/service/zcy.baida.getFormDefineByExpense', {
    method: 'POST',
    data,
  });
};

// 提交报销单
export function submitClaim(data) {
  return query('/zlb/api/expense/expense-form/submit', { method: 'POST', data });
}

// 提交工作流
export const submitWorkFlow = data => {
  return request('/zlb/api/expense/workflow/submit', {
    method: 'POST',
    data,
  });
};

// 发票详情
// export function getInvoiceInfo (params) {
//   return query('/zlb/api/invoice/detailNew', {
//     params,
//   });
// }
// 发票详情
export function getInvoiceInfo(params) {
  return query('/zlb/api/invoice/detail-new', {
    params,
  });
}

// // 撤回工作流
// export const stopWorkFlow = (data) => {
//   return query('/zlb/api/expense/workflow/stop', { method: 'POST', data });
// };

// 审核工作流
export const auditWorkFlow = data => {
  return request('/zlb/api/expense/workflow/audit', {
    method: 'POST',
    data,
  });
};

// 解除申请单绑定关系
export function unboundApplyForm(data) {
  return query('/zlb/api/expense/expense-form/unboundApplyForm', { method: 'POST', data });
}

// 预算列表
export function getBudgetList(data) {
  return query('/zlb/api/expense/budget/query-budget', { method: 'POST', data });
}

// 指标和限额列表组合
export function getBudgetPlanList(data) {
  return query('/zlb/api/expense/budget/query-budget-and-plan-classify', { method: 'POST', data });
}

// 更新报销单信息-财务审核时调用
export function updateClaimForm(data) {
  return query('/zlb/api/expense/expense-form/update', {
    method: 'POST',
    data: omit(data, ['summary_without_code']),
  });
}

// 重新支付
export async function cashierRepay(data) {
  return query('/zlb/api/expense/expense-form/repay', {
    method: 'POST',
    data: omit(data, ['summary_without_code']),
  });
}

// 获取工作流详情
export const getWorkFlowInfoByEdit = params => {
  return request('/zlb/api/expense/workflow/query', {
    params,
  });
};

// 撤回工作流
export const stopWorkFlow = data => {
  return request('/zlb/api/expense/workflow/stop', { method: 'POST', data });
};

// 催办
export function getUrgeForm(params) {
  return query('/zlb/api/expense/common/urge', {
    method: 'GET',
    params,
  });
}
// 课时费校验
export const teachFeeCheck = data => {
  return request('/zlb/api/expense/fee/expenseForm/teachFeeCheck', { method: 'POST', data });
};

// 计算短途包干费用
export const calculateShortDistance = data => {
  // 原来接口/zlb/api/expense/fee/expenseForm/calculateShortDistance
  return request('/zlb/api/expense/fee/expenseForm/batch/calculateShortDistance', {
    method: 'post',
    data,
  });
};
// 查询历史驳回工作流
export const fetchRejectWorkFlow = params => {
  return request('/zlb/api/expense/workflow/reject/history', { params });
};

// 获取报销单支付方式
// 2023-02-28版本已取消使用
// export const reqPayMode = (params) => {
//   return request('/zlb/api/expense/expense-form/getPayMode', { params });
// };

// 发票验真新接口
export const authenticityAgainNew = data => {
  return request('/zlb/api/invoice/authenticityAgainNew', { method: 'POST', data });
};

// 发票验真新接口
export const onOcrRealSave = data => {
  return request('/zlb/api/invoice/real-again-save', { method: 'POST', data });
};

// 根据订单合集查询合同和发票集合
export async function getBindingDetailFromOrder(data) {
  return request('/zlb/api/expense/purchase/order/info', { method: 'POST', data });
}

// export async function getOrderDetailV2(params) {
//   return query(
//     `/zlb/api/expense/purchase/order/approve/info/${params.orderCode}/${params.operatorId || -1}`,
//   );
// }

// 根据订单号查询详情
export async function getOrderDetail(params) {
  return query(
    `/zlb/api/expense/purchase/order/approve/info/${params.orderCode}/${params.operatorId || -1}/${
      params.orderDataSource || 0
    }`,
  );
}

// 根据订单号查询详情
export async function getUnitOrder(orderCode) {
  return query(`/zlb/api/expense/purchase/order/getUnitOrder/${orderCode}`);
}

// 加签
export function addTask(data) {
  return request('/zlb/api/expense/workflow/addTask', {
    method: 'POST',
    data,
  });
}
// 获取交易方式
export async function getTradeWay(params) {
  return query(`/zlb/api/expense/common/dic/getCatalog?${stringify(params)}`);
}

// 获取单个合同详情-zcy
export async function getSingleBatchContractDetail(data) {
  return request('/zlb/api/expense/purchase/contract/expense-detail-zcy', {
    method: 'POST',
    data,
  });
}

// 统一使用新政采云合同接口
// export async function getZcyContractDetail(contractCode) {
//   return query(`/zlb/api/expense/bill-tool/purchase-contract/info/${contractCode}`);
// }

// 根据订单号查询详情
export async function getZcyOrderDetail(orderCode) {
  return query(`/zlb/api/expense/bill-tool/purchase-order/info/${orderCode}`);
}

// 获取合同剩余金额
export async function queryContractRemainingAmount(data) {
  return query('/zlb/api/expense/contract/queryContractRemainingAmount', {
    method: 'POST',
    data,
  });
}

// 获取合同
export async function queryContractExpenseRecord(data) {
  return query('/zlb/api/expense/contract/business-records', {
    method: 'POST',
    data,
  });
}

export async function queryOrderExpenseRecord(data) {
  return query('/zlb/api/expense/purchase/order/expense-records', {
    method: 'POST',
    data,
  });
}

// 从政采云导入合同
export async function reqZcyContractList(data) {
  return request('/zlb/api/expense/purchase/contract/listFromZCY', {
    method: 'POST',
    data,
  });
}

// 根据行程获取数据（凭票报销）
export async function getFeeInvoice(data) {
  return request('/zlb/api/expense/fee/expenseForm/getFeeInvoice', {
    method: 'POST',
    data,
  });
}

// 根据行程获取数据（专用于伙食补贴凭票报销）
export async function getEatFeeInvoiceInfo(data) {
  return request('/zlb/api/expense/fee/expenseForm/getEatFeeInvoiceInfo', {
    method: 'POST',
    data,
  });
}

// 获取当前单位票据验真失败时的签名方式
export async function getSignTypeConfig() {
  return query('/zlb/api/invoice/config/sign/type');
}

// 获取最近一条签名附件
export async function getLastSign() {
  return query('/zlb/api/invoice/config/latest/sign');
}

// 保存签名
export async function saveSign(data) {
  return query('/zlb/api/invoice/config/sign/save', {
    method: 'POST',
    data,
  });
}

// 为发票添加签名
export async function submitSignature(data) {
  return request('/zlb/api/invoice/signature', {
    method: 'POST',
    data,
  });
}

// 批量查询
export async function batchQueryInvoice(data) {
  return request('/zlb/api/invoice/batchQueryDetail', {
    method: 'POST',
    data,
  });
}
/** 根据操作人ID批量查询卡信息 */
export async function getBankCardList(data) {
  return query('/zlb/api/expense/pay/query/bank-card', {
    method: 'POST',
    data,
  });
}
// 保存票据
export function saveZlbpInvoice(data) {
  return request('/zlb/api/invoice/v2/save', { method: 'POST', data });
}
// 查询司机数据
export function getDriverListForClaim(params) {
  return request('/api/zlbuser/identity/driver/pagingDriverBusinessIdentity', {
    method: 'GET',
    params,
  });
}
// 费用类型树（多级，级联显示）
// export function getFeeTypeTree (params) {
//   return request('/zlb/api/expense/common/dic/fee-type-tree/get', { method: 'GET', params });
// }

// 获取业务场景配置
export const reqConfigSceneConfig = data => {
  return request('/zlb/api/expense/config/scene-config', {
    method: 'post',
    data,
  });
};
// 获取唯一编码
export async function getBusinessCode(prefix) {
  return query(`/zlb/api/expense/common/getBusinessCode/${prefix}`);
}

export const getMeetingSignDetail = data => {
  return request('/zlb/api/expense/meeting-sign/queryOne', { params: data });
};

export async function deleteBankCard(accountCode) {
  return query(`/zlb/api/pay/bankCard/delete-by-operatorId/${accountCode}`, {
    method: 'post',
  });
}

// 获取当前租户的使用方式
export async function getUserChannel() {
  return query('/zlb/api/invoice/config/use/channel', { method: 'POST' });
}

export const getReceptionImportResult = params => {
  return request('/zlb/api/expense/reception/import/result', { method: 'GET', params });
};

// 获取租车单选择
export const getRentalList = data => {
  return query('/zlb/api/expense/apply-rental/form-query', { method: 'POST', data });
};

// 判断是否嘉兴租户
export const judgeIsJXTenant = data => {
  return query('/zlb/budget/config/is-jx-dist', { method: 'POST', data });
};

// 判断是否舟山公安机构
export const judgeIsZSPublicSafety = data => {
  return query('/zlb/budget/config/is-zs-gong', { method: 'POST', data });
};

/**
 * 获取区划判断
 * @param {
 *  key: isZcy 政采云-单位 | isWenlingGuotou 温岭国投-单位 | hotelBookIconEnable 杭州市本级-租户  | isScDistrict 上城区-租户 | zlb_expense_travel_itinerary_period_model 行程上下午模式
 *  scope: 1-全局 2-租户 3-单位 4-部门(企业版) [后端配置取消此字段]
 * } data[]
 * @returns
 */
export const fetchBusinessConfig = data => {
  return query('/zlb/api/expense/common/query/business-config', {
    method: 'post',
    data,
  });
};

// 查询支付限额详情
export const fetchPlanClassifyInfo = params => {
  return query('/zlb/budget/plan/classify/info', {
    params,
  });
};

// 百搭+一般事项申请单列表
export const fetchGeneralExpense = data => {
  return query('/zlb/api/search/page/general-expense/apply', {
    method: 'post',
    data,
  });
};

// 公务接待获取导入模板
export const getReceptionImportTemplate = params => {
  return query('/zlb/api/expense/reception/import/template', {
    method: 'GET',
    params,
  });
};

// 获取发票收款人
export const getInoivceReceiver = data => {
  return query('/zlb/api/invoice/manage/receiver/account', {
    method: 'post',
    data,
  });
};
// 支付方式，用途摘要，重新构建
export const getRebuildSummary = data => {
  return query('/zlb/api/expense/expense-form/rebuild-summary', {
    method: 'POST',
    data,
  });
};

// 获取发票费用
export const getFeeInfoByInvoice = data => {
  return query('/zlb/api/expense/fee/expense-form/general/gen-by-invoice', {
    method: 'post',
    data,
  });
};
/**
 * 获取某个平台级摘要的配置
 * @param {{subTypeCode: string, configCode: string}} data - 请求参数
 * @param {string} data.subTypeCode - business-scene返回的subTypeCode
 * @param {string} data.configCode - 配置项,EXPENSE_RELATED_APPLY 报销单是否必须关联申请单；TRANS_DEPARTMENT 是否支持跨部门申请
 * @return {Promise} - request 实例
 */
export const getSummaryConfig = data => {
  return query('/zlb/api/expense/config/query-summary-config-enable', {
    method: 'post',
    data,
  });
};

// 合同/订单/付款信息交易
export const purchaseTradeCheck = data => {
  return query('/zlb/api/expense/purchase/trade/check', {
    method: 'post',
    data,
  });
};
// 一般事项根据扣款凭证获取费用
export const genByDebitNote = data => {
  return query('/zlb/api/expense/fee/expense-form/general/gen-by-debit-note', {
    method: 'post',
    data,
  });
};

// 交易信息初始化
export const purchaseTradeInit = data => {
  return query('/zlb/api/expense/purchase/trade/init', {
    method: 'post',
    data,
  });
};
/**
 * 合同导入
 * 针对2个情况：1. 合同中心-政采云合同 2.报销单中-添加政采云合同
 */
export const batchImportContract = data => {
  return query('/zlb/api/expense/contract/batch-import', {
    method: 'post',
    data,
  });
};
// 是否开启小额托收
export const getSmallTransferEnable = params => {
  return request('/zlb/api/expense/small-transfer/general/enable', {
    method: 'GET',
    params,
  });
};
// 用费用判断是否是是全电还是非全电
export const getElectronicInvoiceTypeByFee = data => {
  return request('/zlb/api/expense/fee/expense-form/electronic/invoice/gen-by-fee', {
    method: 'POST',
    data,
  });
};

// 查询关联的一体化预算指标列表详情 bpuUkList
export const budgetProjectUseRelatedBudgetList = data => {
  return query('/zlb/budget/ep/project-use/related-budget/list', {
    method: 'post',
    data,
  });
};
// 获取当前单据的凭证信息
export const getFeeInvoiceVoucher = params => {
  return request('/zlb/api/expense/fee/fee-invoice/voucher/init', {
    method: 'GET',
    params,
  });
};

// 计算当前单据的凭证信息
export const calcFeeInvoiceVoucher = data => {
  return query('/zlb/api/expense/fee/fee-invoice/voucher/calculate', {
    method: 'post',
    data,
  });
};
